// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconQuestion: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <path
                fill="#999"
                d="M420,1206 C416.685938,1206 414,1208.68594 414,1212 C414,1215.31406 416.685938,1218 420,1218 C423.314062,1218 426,1215.31406 426,1212 C426,1208.68594 423.314062,1206 420,1206 Z M420,1216.875 C417.311719,1216.875 415.125,1214.68805 415.125,1212 C415.125,1209.31195 417.311719,1207.125 420,1207.125 C422.688282,1207.125 424.875,1209.31195 424.875,1212 C424.875,1214.68805 422.688282,1216.875 420,1216.875 Z M420,1213.875 C419.578125,1213.875 419.25,1214.20312 419.25,1214.625 C419.25,1215.04688 419.557031,1215.375 420,1215.375 C420.400781,1215.375 420.75,1215.04688 420.75,1214.625 C420.75,1214.20312 420.400781,1213.875 420,1213.875 Z M420.775781,1209 L419.578125,1209 C418.664062,1209 417.9375,1209.72656 417.9375,1210.64062 C417.9375,1210.94531 418.195312,1211.20312 418.5,1211.20312 C418.804688,1211.20312 419.0625,1210.94531 419.0625,1210.64062 C419.0625,1210.35938 419.275781,1210.125 419.557031,1210.125 L420.754688,1210.125 C421.057031,1210.125 421.3125,1210.35938 421.3125,1210.64062 C421.3125,1210.82812 421.21875,1210.97109 421.054688,1211.06484 L419.71875,1211.88281 C419.53125,1212 419.4375,1212.1875 419.4375,1212.375 L419.4375,1212.75 C419.4375,1213.05469 419.695312,1213.3125 420,1213.3125 C420.304688,1213.3125 420.5625,1213.05469 420.5625,1212.75 L420.5625,1212.70312 L421.619531,1212.04688 C422.111719,1211.74219 422.416406,1211.20312 422.416406,1210.64062 C422.4375,1209.72656 421.710938,1209 420.775781,1209 Z"
                transform="translate(-414 -1206)"
            />
        </svg>
    );
};

export default React.memo(IconQuestion);
